import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import ProductVariationsService from 'shared/services/ProductVariationsService';
import {
  getAllProductVariations,
  getProductVariationFail,
  setProductVariationData
} from './productVariations.redux';

import { TAction, TPaginationRequest } from 'shared/types';
import { IProductVariation } from 'shared/interfaces/product-variation.interface';

function* getProducts({ payload }: TAction<TPaginationRequest>) {
  try {
    const result: AxiosResponse<IProductVariation[]> = yield call(
      ProductVariationsService.getProductVariations,
      payload
    );
    yield put(setProductVariationData(result.data));
  } catch (error) {
    console.log('error', error);
    yield put(getProductVariationFail());
  }
}
function* ProductVariations() {
  yield takeLatest(getAllProductVariations.type, getProducts);
}

export default ProductVariations;
